<template>
    <v-row>
        <v-col>
            <v-col sm="12">
                <v-row>
                    <v-col cols="12" sm="6">
                        <h3 class="pl-3" v-text="$t('einstellungen.teilnehmerzugriff.title')" />
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex flex-column flex-wrap flex-sm-row justify-sm-end ga-2">
                        <!-- Treuhand Button -->
                        <div class="flex-grow-1 flex-sm-grow-0 equal-btn">
                            <AddTeilnehmerZugriffDialog
                                :dialog-title="$t('einstellungen.teilnehmerzugriff.dialog.treuhand.title')"
                                :dialog-infotext="$t('einstellungen.teilnehmerzugriff.dialog.infotext.treuhand')"
                                :benutzer-rolle-label="$t('benutzerrollen.treuhand')"
                                teilnehmer-typ="treuhand"
                            />
                        </div>
                        <!-- Praxisgruppe Button -->
                        <div class="flex-grow-1 flex-sm-grow-0 equal-btn">
                            <AddTeilnehmerZugriffDialog
                                :dialog-title="$t('einstellungen.teilnehmerzugriff.dialog.title')"
                                :dialog-infotext="$t('einstellungen.teilnehmerzugriff.dialog.infotext.praxisgruppe')"
                                :benutzer-rolle-label="$t('benutzerrollen.praxisgruppe')"
                                teilnehmer-typ="praxisgruppe"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-data-table
                :headers="headers"
                :items="teilnehmerZugriffList"
                item-key="teilnehmerName"
                disable-pagination
                hide-default-footer
                class="elevation-1 nowhow-table"
                :must-sort="true"
                :items-per-page="-1"
            >
                <template #item.teilnehmerZugriffTyp="{ item }">
                    <span>
                        {{ $t('benutzerrollen.' + item.teilnehmerZugriffTyp.toLowerCase()) }}
                    </span>
                </template>
                <template #item.action="{ item }">
                    <ConfirmDialog
                        title="einstellungen.teilnehmerzugriff.deleteTitle"
                        text="einstellungen.teilnehmerzugriff.deleteText"
                        @confirm="deleteTeilnehmerZugriff(item.teilnehmerZugriffId)"
                    >
                        <template #activatorElement="{ props }">
                            <v-btn icon v-bind="props" flat>
                                <v-icon color="primary" icon="mdi-delete" />
                            </v-btn>
                        </template>
                    </ConfirmDialog>
                </template>
            </v-data-table>
        </v-col>
    </v-row>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator';
import { namespace } from 'vuex-facing-decorator';
import { TeilnehmerZugriffApiDto } from '@/api-schema';

import { NAME as NAME_EINSTELLUNGEN } from '../store';
const profilModul = namespace(NAME_EINSTELLUNGEN);
import { DELETE_TEILNEHMER_ZUGRIFF } from '../store/actions';

import ConfirmDialog from '@/components/ConfirmDialog.vue';
import AddTeilnehmerZugriffDialog from './AddTeilnehmerZugriffDialog.vue';
@Component({
    components: {
        ConfirmDialog,
        AddTeilnehmerZugriffDialog
    }
})
export default class TeilnehmerZugriffListe extends Vue {
    @Prop({ required: true, type: Array })
    private teilnehmerZugriffList!: Array<TeilnehmerZugriffApiDto>;

    @profilModul.Action(DELETE_TEILNEHMER_ZUGRIFF) deleteTeilnehmerZugriff!: Function;

    get headers(): Array<any> {
        return [
            {
                title: this.$t('einstellungen.teilnehmerzugriff.table.teilnehmer'),
                key: 'teilnehmerName'
            },
            {
                title: this.$t('einstellungen.teilnehmerzugriff.table.berechtigung'),
                key: 'teilnehmerZugriffTyp'
            },
            {
                title: this.$t(''),
                key: 'action',
                align: 'center',
                width: '10',
                sortable: false
            }
        ];
    }
}
</script>
